<script>
import appConfig from '@src/app.config'

export default {
  props: ['item', 'mls_field_values'],
  data() {
    return {

    }
  },
  created() {
    if(!this.item.Conditional) { this.item.Conditional = []; }

    // reso
    // custom
    // html
    // widget

    // "String" Text Input
    // "String List, Single" Select Dropdown, Single
    // "String List, Multi" Select Dropdown, Multi
    // "Textarea" Textarea
    // "Money" Money
    // "Number" Number
    // "Boolean" Checkbox
    // "Date" Date
    // "Date and time" Date and time
  },
  methods: {

  }
}
</script>


<template>

  <span class="">

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label for="input-col_sm" v-tippy content="Mobile column width out of 12">Mobile column width <Icon icon="ri:information-fill" class="text-muted" /></label>
          <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text bg-white"><Icon icon="ri:smartphone-line" /></span></div>
            <input id="input-col_sm" type="number" min="1" max="12" class="form-control" v-model="item.col_sm">
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label for="input-col_lg" v-tippy content="Desktop column width out of 12">Desktop column width <Icon icon="ri:information-fill" class="text-muted" /></label>
          <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text bg-white"><Icon icon="ri:computer-line" /></span></div>
            <input id="input-col_lg" type="number" min="1" max="12" class="form-control" v-model="item.col_lg">
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label for="input-align" v-tippy content="Section alignment">Section alignment <Icon icon="ri:information-fill" class="text-muted" /></label>
          <div class="input-group">
            <div class="input-group-prepend"><span class="input-group-text bg-white"><Icon icon="ri:align-center" /></span></div>
            <select id="input-align" class="form-control" v-model="item.align">
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div v-if="item.FieldType == 'html'" class="form-group">
      <label v-tippy content="HTML content">HTML content <Icon icon="ri:information-fill" class="text-muted" /></label>
      <ck-rich-editor v-model="item.Default"></ck-rich-editor>
    </div>

    <div v-else-if="item.FieldType == 'reso' || item.FieldType == 'custom'">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-SimpleDataType" v-tippy content="Field type">Field type <Icon icon="ri:information-fill" class="text-muted" /></label>
            <select id="input-SimpleDataType" class="form-control mb-1" v-model="item.SimpleDataType">
              <option value="" disabled selected>Select...</option>
              <option value="String">Text input</option>
              <option value="String List, Single">Select dropdown, single</option>
              <option value="String List, Multi">Select dropdown, multi</option>
              <option value="Textarea">Textarea</option>
              <!-- <option value="Money">Money</option> -->
              <option value="Number">Number</option>
              <option value="Boolean">Checkbox</option>
              <option value="Date">Date</option>
              <option value="Date and time">Date and time</option>
            </select>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-Title" v-tippy content="Title">Title <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Title" type="text" class="form-control" v-model="item.Title"></input>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-SpanishStandardName" v-tippy content="Spanish title">Spanish title <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-SpanishStandardName" type="text" class="form-control" v-model="item.SpanishStandardName"></input>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-StandardName" v-tippy content="Data ID for PDF mapping">Data ID <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-StandardName" type="text" class="form-control" v-model="item.StandardName"></input>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="input-Default" v-tippy content="Default value">Default value <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Default" type="text" class="form-control" v-model="item.Default"></input>
          </div>
        </div>
        <div class="col-sm-4" v-if="
          item.SimpleDataType == 'Date' ||
          item.SimpleDataType == 'Date and time'
          ">
          <div class="form-group">
            <label for="input-Min" v-tippy content="Number of days before or after the current date to START allowing date selection. For example -2 would make the minimum selectable date be two days ago were as 2 would make the minimum selectable date be two days from now. Leaving this empty will allow any minimum date selection.">Limit min date <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Min" type="number" class="form-control" v-model="item.Min"></input>
          </div>
        </div>
        <div class="col-sm-4" v-if="
          item.SimpleDataType == 'Date' ||
          item.SimpleDataType == 'Date and time'
          ">
          <div class="form-group">
            <label for="input-Max" v-tippy content="Number of days before or after the current date to STOP allowing date selection. For example -2 would make the maximum selectable date be two days ago were as 2 would make the maximum selectable date be two days from now. Leaving this empty will allow any maximum date selection.">Limit max date <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Max" type="number" class="form-control" v-model="item.Max"></input>
          </div>
        </div>
        <div class="col-sm-4" v-if="
          item.SimpleDataType == 'Number'
          ">
          <div class="form-group">
            <label for="input-Min" v-tippy content="Min value">Min value <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Min" type="number" class="form-control" v-model="item.Min"></input>
          </div>
        </div>
        <div class="col-sm-4" v-if="
          item.SimpleDataType == 'Number'
          ">
          <div class="form-group">
            <label for="input-Max" v-tippy content="Max value">Max value <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Max" type="number" class="form-control" v-model="item.Max"></input>
          </div>
        </div>
        <div class="col-sm-4" v-if="
          item.SimpleDataType == 'String' ||
          item.SimpleDataType == 'Textarea'
          ">
          <div class="form-group">
            <label for="input-Max" v-tippy content="Max characters">Max characters <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Max" type="number" class="form-control" v-model="item.Max"></input>
          </div>
        </div>
        <div class="col-sm-4" v-if="
          item.SimpleDataType == 'String List, Multi'
          ">
          <div class="form-group">
            <label for="input-Max" v-tippy content="Max selections">Max selections <Icon icon="ri:information-fill" class="text-muted" /></label>
            <input id="input-Max" type="number" class="form-control" v-model="item.Max"></input>
          </div>
        </div>

        <div class="col-sm-12">
          <label for="input-options" v-tippy content="Synonyms">Synonyms <Icon icon="ri:information-fill" class="text-muted" /></label>

          <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.Synonym">
            <transition-group tag="div">
              <div v-for="(synonym, synonym_i) in item.Synonym" :key="'a'+synonym_i" class="input-group mb-1">
                <input type="text" class="form-control" placeholder="Synonym title" v-model="item.Synonym[synonym_i]" v-tippy content="Synonym title">
                <div class="input-group-append">
                  <button class="btn btn-outline-light bg-white" type="button" v-tippy content="Delete synonym" @click="item.Synonym.splice(synonym_i, 1)"><Icon icon="ri:delete-bin-7-line" /></button>
                  <button class="btn btn-outline-light bg-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill" /></button>
                </div>
              </div>
            </transition-group>
          </draggable>

          <div class="mb-2">
            <button class="btn btn-sm btn-success py-0 px-1" type="button" v-tippy content="Add synonym" @click="item.Synonym.push('')"><Icon icon="ri:add-line" /> Add synonym</button>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <label for="input-Definition" v-tippy content="Input description">Input description <Icon icon="ri:information-fill" class="text-muted" /></label>
            <textarea id="input-Definition" class="form-control" rows="3" v-model="item.Definition"></textarea>
          </div>
        </div>

        <div class="col-sm-12" v-if="
          item.SimpleDataType == 'String List, Single' ||
          item.SimpleDataType == 'String List, Multi'
          ">
          <label for="input-options" v-tippy content="Select options">Select options <Icon icon="ri:information-fill" class="text-muted" /></label>

          <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.Options">
            <transition-group tag="div">
              <div v-for="(option, option_i) in item.Options" :key="'a'+option_i" class="input-group mb-1">
                <input type="text" class="form-control" placeholder="Option title" v-model="item.Options[option_i]" v-tippy content="Option title">
                <div class="input-group-append">
                  <button class="btn btn-outline-light bg-white" type="button" v-tippy content="Delete option" @click="item.Options.splice(option_i, 1)"><Icon icon="ri:delete-bin-7-line" /></button>
                  <button class="btn btn-outline-light bg-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill" /></button>
                </div>
              </div>
            </transition-group>
          </draggable>

          <div class="mb-2">
            <button class="btn btn-sm btn-success py-0 px-1" type="button" v-tippy content="Add option" @click="item.Options.push('')"><Icon icon="ri:add-line" /> Add option</button>
          </div>
        </div>

      </div>
    </div>

 
    <div class="">
      <div class="form-group">
        <label for="input-PropertyTypes" v-tippy :content="
          `<div class='text-left'>`+
          `RESI (Residential)<br>`+
          `RLSE (Residential Lease)<br>`+
          `RINC (Residential Income)<br>`+
          `LAND (Land)<br>`+
          `MOBI (Mobile)<br>`+
          `FARM (Farm)<br>`+
          `COMS (Commercial Sale)<br>`+
          `COML (Commercial Lease)<br>`+
          `BUSO (Business Opportunity)<br>`+
          `</div>`
          ">Property types <Icon icon="ri:information-fill" class="text-muted" />
        </label>
        <!-- 'RESI',
        'RLSE',
        'RINC',
        'LAND',
        'MOBI',
        'FARM',
        'COMS',
        'COML',
        'BUSO' -->
        <multiselect id="input-PropertyTypes" v-model="item.PropertyTypes" :options="[
          'RESI',
          'LAND'
          ]" :taggable="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" open-direction="bottom" placeholder="Select...">
        </multiselect>
      </div>
    </div>

    <div class="">
      <label for="input-options" v-tippy content="Synonyms">Conditional formatting <Icon icon="ri:information-fill" class="text-muted" /></label>

      <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.Conditional">
        <transition-group tag="div">
          <div v-for="(condition, condition_i) in item.Conditional" :key="'c'+condition_i" class="input-group mb-1">
            <div class="input-group-prepend">
              <select id="input-SimpleDataType" class="form-control _w-m-150" v-model="condition.action">
                <option value="" disabled selected>Select...</option>
                <option value="hidden_if">Hidden if</option>
                <option value="require_if">Required if</option>
              </select>
            </div>
            <div class="input-group-prepend">
              <select id="input-SimpleDataType" class="form-control _w-m-150" v-model="condition.field">
                <option value="" disabled selected>Select...</option>
                <option v-for="(tableitem, tableitem_i) in mls_field_values" :key="tableitem_i" :value="tableitem_i">{{tableitem_i}}</option>
              </select>
            </div>
            <div class="input-group-prepend">
              <select id="input-SimpleDataType" class="form-control _w-m-150" v-model="condition.condition">
                <option value="" disabled selected>Select...</option>
                <option value="any_value">Has any value</option>
                <option value="emtpy">Is emtpy</option>
                <option value="equal_to">Value is equal to</option>
                <option value="not_equal_to">Value is NOT equal to</option>
              </select>
            </div>
            <input type="text" class="form-control" placeholder="Value" v-tippy content="Value" v-model="condition.value">
            <div class="input-group-append">
              <button class="btn btn-outline-light bg-white" type="button" v-tippy content="Delete synonym" @click="item.Conditional.splice(condition_i, 1)"><Icon icon="ri:delete-bin-7-line" /></button>
              <button class="btn btn-outline-light bg-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill" /></button>
            </div>
          </div>
        </transition-group>
      </draggable>

      <div class="mb-2">
        <button class="btn btn-sm btn-success py-0 px-1" type="button" v-tippy content="Add synonym" @click="item.Conditional.push({
          action: '',
          field: '',
          condition: '',
          value: '',
          })"><Icon icon="ri:add-line" /> Add conditional formatting</button>
      </div>
    </div>

    <div v-if="item.FieldType == 'reso' || item.FieldType == 'custom'">
      <div class=""><label v-tippy content="Input settings">Input settings <Icon icon="ri:information-fill" class="text-muted" /></label></div>
      <toggle-button class="mr-2" v-model="item.Required" :width="110" :labels="{checked: 'Required', unchecked: 'Not required'}" />
      <toggle-button class="mr-2" v-model="item.Hidden" :width="110" :labels="{checked: 'Hidden', unchecked: 'Not hidden'}" />
      <toggle-button v-model="item.Disabled" :width="110" :labels="{checked: 'Disabled', unchecked: 'Not disabled'}" />
    </div>

  </span>

</template>
